import { IMAGE_RESOLUTION_SMALL, IMAGE_RESOLUTION_WIDE, ImageSizeType, NAVIGATION_BUTTONS_HEIGHT } from '../consts';
const getAspectRatio = (imageResolution) => {
    return `${(imageResolution.height / imageResolution.width) * 100}`;
};
export const getBannerHeight = ({ imageSize, unit = 'vw' }) => {
    if (imageSize === ImageSizeType.WIDE) {
        return `calc(${getAspectRatio(IMAGE_RESOLUTION_WIDE)}${unit} + ${NAVIGATION_BUTTONS_HEIGHT})`;
    }
    return `${getAspectRatio(IMAGE_RESOLUTION_SMALL)}${unit}`;
};
export const getBannerMaxHeight = ({ imageSize, unit = 'px' }) => {
    if (imageSize === ImageSizeType.WIDE) {
        return `calc(${IMAGE_RESOLUTION_WIDE.height}${unit} + ${NAVIGATION_BUTTONS_HEIGHT})`;
    }
    return `${IMAGE_RESOLUTION_SMALL.height}${unit}`;
};
export const getImageMaxHeight = ({ imageSize, unit = 'px' }) => {
    if (imageSize === ImageSizeType.WIDE) {
        return `${IMAGE_RESOLUTION_WIDE.height}${unit}`;
    }
    return `${IMAGE_RESOLUTION_SMALL.height}${unit}`;
};
export const getImageHeight = ({ imageSize, unit = 'vw' }) => {
    if (imageSize === ImageSizeType.WIDE) {
        return `${getAspectRatio(IMAGE_RESOLUTION_WIDE)}${unit}`;
    }
    return `${getAspectRatio(IMAGE_RESOLUTION_SMALL)}${unit}`;
};
export const getImageMaxWidth = ({ imageSize, unit = 'px' }) => {
    if (imageSize === ImageSizeType.WIDE) {
        return `${IMAGE_RESOLUTION_WIDE.width}${unit}`;
    }
    return `${IMAGE_RESOLUTION_SMALL.width}${unit}`;
};
export const isImageWide = (imageSize) => imageSize === ImageSizeType.WIDE;
